import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BaseAPIObject, BaseApiService } from './base-api.service';
import { HelpersService } from './helpers.service';
import { Projects } from './projects';
export interface ProjectCounter{
  comments: number;
  documents: number;
  invoices: number;
  issues: number;
  jobs: number;
  payments: number;
  subscriptions: number;
}
@Injectable({
  providedIn: 'root'
})
export class ProjectsService extends BaseApiService<Projects> {

  constructor(
    public http: HttpClient,
    public helper: HelpersService
    ) {
      super(http, helper);
      this.endpoint = 'projects';
    }
    
    projectDetailCounter(id): Observable<BaseAPIObject<ProjectCounter>> {
      const url = this.url_array([id, 'counter']);
      return this.http.get<BaseAPIObject<ProjectCounter>>(url);
    }
    
    projectStatistic() {
      const url = this.url_array(['statistik']);
      return this.http.get<any>(url);
    }

    projectStatisticDetail(id) {
      const url = this.url_array(['statistik', id, 'detail'])
      return this.http.get<any>(url);
    }
    
    jobTask(id) {
      const url = this.url_array([id, 'job-task']);
      return this.http.get<any>(url);
    }
    
    progress(id, jobType = 'Main'){
      const url = this.url_array(['progress', id, jobType]);
      return this.http.get<any>(url);
    }

    duplicate(from, to, data) {
      const url = this.url_array([to, 'copy', from]);
      return this.http.post<any>(url, data);
    }

    import(data) {
      const url = this.url_custom('import');
      return this.http.post<any>(url, data);
    }

    getAuctionCode() {
      const url = this.url_custom('auction-code');
      return this.http.get<any>(url);
    }

    getProjectForImport(id) {
      const url = this.url_array([id, 'for-import'])
      return this.http.get<any>(url);
    }
    
    getProjectPIC(id) {
      const url = this.url_array([id, 'pic']);
      return this.http.get<any>(url);
    }

  }
